import { Stack } from '@mui/material';
import { Role } from './role/Role';
import { useSelector } from 'react-redux';
import { selectIsLoadingRoleGroups, selectRoleGroups } from '../../../reducers/roleGroupsReducer';
import type { UserDefinedRoleGroupsInterface } from '@server/role-group-interface';
import { CenteredCircularProgress } from '../../common/CenteredCircularProgress';
import { sortRoles } from './utils';

interface RoleListProps {
  setEditRole: (role: UserDefinedRoleGroupsInterface) => void;
}

export const RoleList = ({ setEditRole }: RoleListProps) => {
  const roles = useSelector(selectRoleGroups);
  const isLoading = useSelector(selectIsLoadingRoleGroups);
  const sortedRoles = sortRoles(roles ?? []);

  return (
    <Stack>
      {isLoading && <CenteredCircularProgress />}
      {!isLoading &&
        sortedRoles.map((role) => (
          <Role role={role} key={role.id} onClick={() => setEditRole(role)} />
        ))}
    </Stack>
  );
};
